document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.product-media-slider').forEach(function(slider) {
    const slidesContainer = slider.querySelector('.slides');
    const slides = slider.querySelectorAll('.slide');
    const prevButton = slider.querySelector('.prev-slide');
    const nextButton = slider.querySelector('.next-slide');
    const dots = slider.querySelectorAll('.slider-dot');
    // Get the overlay and the figure container.
    const overlay = slider.parentElement.querySelector('.product-card__link-overlay');
    const figure = slider.closest('.product-card__figure');
    
    let currentSlide = 0;
    const totalSlides = slides.length;
    
    // Variables for swipe detection.
    let touchStartX = 0;
    let touchEndX = 0;
    let swiped = false;
    let touchStartTime = 0;
    const threshold = 50; // Minimum swipe distance (in pixels)
    
    function showSlide(index) {
      slidesContainer.style.transform = `translateX(-${index * 100}%)`;
      currentSlide = index;
      dots.forEach((dot, i) => {
        dot.classList.toggle('active', i === currentSlide);
      });
    }
    
    // Initialize slider.
    showSlide(0);
    
    // Arrow button click events (desktop only)
    if (prevButton) {
      prevButton.addEventListener('click', function(e) {
        e.stopPropagation();
        showSlide((currentSlide - 1 + totalSlides) % totalSlides);
      });
    }
    if (nextButton) {
      nextButton.addEventListener('click', function(e) {
        e.stopPropagation();
        showSlide((currentSlide + 1) % totalSlides);
      });
    }
    
    // Dot pagination click events.
    dots.forEach(dot => {
      dot.addEventListener('click', function(e) {
        e.stopPropagation();
        const index = parseInt(dot.dataset.index, 10);
        showSlide(index);
      });
    });
    
    // ---------------------------
    // Swipe Detection on Mobile
    // Attach touch events to the slides container.
    // ---------------------------
    slidesContainer.addEventListener('touchstart', function(e) {
      touchStartX = e.changedTouches[0].screenX;
      touchStartTime = new Date().getTime();
      swiped = false;
    }, { passive: true });
    
    slidesContainer.addEventListener('touchmove', function(e) {
      touchEndX = e.changedTouches[0].screenX;
      if (Math.abs(touchStartX - touchEndX) > threshold) {
        swiped = true;
      }
    }, { passive: true });
    
    slidesContainer.addEventListener('touchend', function(e) {
      touchEndX = e.changedTouches[0].screenX;
      const diff = touchStartX - touchEndX;
      const duration = new Date().getTime() - touchStartTime;
      if (Math.abs(diff) > threshold && duration > 50) {
        if (diff > 0) {
          // Swiped left: next slide.
          showSlide((currentSlide + 1) % totalSlides);
        } else {
          // Swiped right: previous slide.
          showSlide((currentSlide - 1 + totalSlides) % totalSlides);
        }
      }
      // Reset swiped flag.
      setTimeout(() => { swiped = false; }, 0);
    }, { passive: true });
    
    // ---------------------------
    // Mobile Tap Navigation
    // On mobile, attach a click event to the entire figure.
    // If no swipe was detected, navigate to the product page.
    // ---------------------------
    if (window.innerWidth <= 767 && figure && overlay) {
      figure.addEventListener('click', function(e) {
        // Only navigate if a swipe did not occur.
        if (!swiped) {
          // Use the overlay's href attribute.
          window.location.href = overlay.href;
        }
      });
    }
  });
});
